<template>
    <v-container>
        <div class="mt-5" v-for="(skill, i) in skills" :key="i">
            <v-card class="d-flex justify-space-between" color="blue-grey lighten-2">
                <v-card class="row ma-1 title">
                    <v-card-actions>
                        <a :href="skill.company.url" target="_blank" class="black--text font-italic" rel="noopener noreferrer">{{skill.company.name}}</a>
                    </v-card-actions>
                </v-card>
                <v-card class="row ma-1">
                    <v-card-text>
                        <div class="subtitle-1 black--text pt-2 font-italic">{{ skill.description }}</div>
                    </v-card-text>
                </v-card>
                <v-card class="row ma-1">
                    <v-card-text>
                        <div class="subtitle-1 black--text pt-2 font-italic">{{ skill.responsibility }}</div>
                    </v-card-text>
                </v-card>
                <v-card class="row ma-1">
                    <v-card-text>
                        <div class="subtitle-1 pt-2">
                            <v-card-actions>
                                <a class="ml-2 black--text font-italic" v-for="project in skill.projects" :key="project.url" :href="project.url" target="_blank">
                                    {{project.title + ","}} 
                                </a> 
                            </v-card-actions>
                        </div>
                    </v-card-text>
                </v-card>
            </v-card>
            </div>
    </v-container>
</template>
<script>
  export default {
    data: () => ({
      colors: ['deep-purple', 'deep-purple', 'deep-purple', 'deep-purple', 'deep-purple'],
      skills:[
          {
              company:{name: 'Shadhin Fintech Solution', url: 'https://shadhinbd.com/'},
              description: 'Bangladesh’s first Peer to Peer (Person to Person) Funding App. Connecting you to other peers (Persons) to help you achieve your life goals! Shadhin is an intermediary providing matchmaking services via an Online Platform/App for Individuals looking for quick funding from other Individuals. Get Funded by other Peers (Persons) within a week for upto 1 LAKH Taka! Zero PaperWork, Submit application in only 3 steps in 10 minutes. No Security or Collateral Needed! Get Funds for as low as 10,000 taka and upto 100,000 taka with a low fee.', 
              responsibility: 'Full Stack Developer & Back-end team lead',
              projects: [
                { url:'https://play.google.com/store/apps/details?id=com.shadhinbd.investee', title:'investee app'},
                { url:'https://play.google.com/store/apps/details?id=com.shadhinbd.investor', title:'investor app'}
              ]
          },
          {
              company:{name: 'Datadash the data collecting platform', url: 'https://clementinedatabd.com/'},
              description: 'Bangladesh\'s first data collecting platform. Get paid to collect data, perform surveys, take photos and capture videos. DataDash pays you to collect data, perform surveys, take photos and capture videos in your city! Earn money when it\'s convenient - choose requests that you want to complete. No experience necessary - we support you by providing training and guidance. Fulfill requests at specific locations or anywhere in your city. GPS helps find requests that are near you. DataDash operates nearly everywhere around the country.', 
              responsibility: 'Full Stack Developer & Back-end team lead',
              projects: [
                { url:'http://admindd.clementinedatabd.com/', title: 'datadash admin panel'},
                { url:'https://play.google.com/store/apps/details?id=com.clementinedatabd.datadash', title: 'datadash app'}
              ]
          },
          {
              company:{name: 'Email Marketing', url: 'https://www.ctmt-ltd.com/'},
              description: 'This software is focused on large-scale email marketing. You can use multiple SMTP or php mail at the same time with mailgun, Amazon ses, Maildrill API. This is SaaS version. There are options to make packages for your customer. You can run your own business like MailChimp or other email service provider.', 
              responsibility: 'Back-end and front-end Developer',
              projects: [
                { url:'https://codecanyon.net/item/email-marketing/16798044', title: 'email marketing tools for codecanyon'}
              ]
          },
          {
              company:{name: 'Url Shortener', url: 'https://www.ctmt-ltd.com/'},
              description: 'Secure URL Shortening System. Eearn money from google adsense or any other platform’s advertisement. Short link Social Share Option. Short link Statistics. Short link Advertisement. Short link History. Easy User Management. 404 page if short URL not found. Beautiful Dashboard. Two type advertise, Google Adsense or any js ad code and image with redirect link. SEO friendly HTML5 Mark-up. Responsive Design. Multi language support. Beautiful track log system. Social app authentication.', 
              responsibility: 'Front end editing',
              projects: [
                { url:'https://short.xcoder.io/', title: 'url shortener'},
                { url:'https://codecanyon.net/item/shorten-url-with-advertisement/17421211', title: 'codecanyoon link'},
              ]
          }
      ]
    }),
    methods: {
      genColor (i) {
        return this.colors[i]
      },
    },
  }
</script>